export default __webpack_public_path__ + "img/pdf.bdb89c42.png";